import { IMultiLanguage, MultiLanguage } from '@/shared/model/multi-language.model';
import { IDiscount } from '@/shared/model/discount.model';
import { IMenu } from '@/shared/model/menu.model';
import { IAvailability } from '@/shared/model/availability.model';
import { IRestaurant } from '@/shared/model/restaurant.model';

export interface IMenuCategory {
  id?: number;
  ordinal?: number | null;
  imageContentType?: string | null;
  image?: string | null;
  imagePath?: string | null;
  enabled?: boolean | null;
  nonfood?: boolean | null;
  title?: IMultiLanguage | null;
  titleValue?: string | null;
  description?: IMultiLanguage | null;
  discount?: IDiscount | null;
  menus?: IMenu[] | null;
  availabilities?: IAvailability[] | null;
  restaurant?: IRestaurant | null;
}

export class MenuCategory implements IMenuCategory {
  constructor(
    public id?: number,
    public ordinal?: number | null,
    public imageContentType?: string | null,
    public image?: string | null,
    public imagePath?: string | null,
    public enabled?: boolean | null,
    public nonfood?: boolean | null,
    public title?: IMultiLanguage | null,
    public titleValue?: string | null,
    public description?: IMultiLanguage | null,
    public discount?: IDiscount | null,
    public menus?: IMenu[] | null,
    public availabilities?: IAvailability[] | null,
    public restaurant?: IRestaurant | null
  ) {
    this.enabled = this.enabled ?? true;
    this.nonfood = this.nonfood ?? false;
    this.description = this.description ?? new MultiLanguage();
    this.menus = this.menus ?? [];
    this.availabilities = this.availabilities ?? [];
  }
}
